"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var S = __importStar(require("./LftGrid.styles"));
var LftGrid = function (_a) {
    var _b = _a.alignItems, alignItems = _b === void 0 ? 'flex-start' : _b, alignSelf = _a.alignSelf, children = _a.children, container = _a.container, dataSection = _a.dataSection, dataTestId = _a.dataTestId, _c = _a.flexDirection, flexDirection = _c === void 0 ? 'row' : _c, fluid = _a.fluid, item = _a.item, _d = _a.justifyContent, justifyContent = _d === void 0 ? 'flex-start' : _d, section = _a.section, spacing = _a.spacing, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, _e = _a.xl, xl = _e === void 0 ? 12 : _e, props = __rest(_a, ["alignItems", "alignSelf", "children", "container", "dataSection", "dataTestId", "flexDirection", "fluid", "item", "justifyContent", "section", "spacing", "xs", "sm", "md", "lg", "xl"]);
    if (!section) {
        var breakpointsValues = [xs, sm, md, lg, xl];
        breakpointsValues = breakpointsValues.reduce(function (_, cur, i, arr) {
            if (cur === undefined) {
                var nextDefinedValue = arr.slice(i).find(function (val) { return val !== undefined; });
                arr[i] = nextDefinedValue !== undefined ? nextDefinedValue : cur;
            }
            return arr;
        }, breakpointsValues);
        var className = ((container ? 'LftContainer' : '') + " " + (item ? 'LftItem' : '')).trim();
        return ((0, jsx_runtime_1.jsx)(S.Content, __assign({}, props, { xs: breakpointsValues[0], sm: breakpointsValues[1], md: breakpointsValues[2], lg: breakpointsValues[3], xl: breakpointsValues[4], alignSelf: alignSelf, container: container, item: item, className: className, "data-lift": "lft-grid-content", "data-section": dataSection && "section_" + dataSection, "data-testid": dataTestId, alignItems: alignItems, spacing: spacing, flexDirection: flexDirection, justifyContent: justifyContent }, { children: children }), void 0));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(S.Section, __assign({ "data-lift": "lft-grid-section", "data-section": dataSection && "section_" + dataSection, "data-testid": dataTestId, fluid: fluid }, { children: (0, jsx_runtime_1.jsx)(S.SectionWrapper, __assign({}, props, { alignItems: alignItems, flexDirection: flexDirection, justifyContent: justifyContent }, { children: children }), void 0) }), void 0));
    }
};
exports.default = LftGrid;
